import Tooltip from 'components/ui/Tooltip'
import { CheckBadgeIcon, CheckCircleIcon } from '@heroicons/react/24/solid'
import {
  CheckCircleIcon as CheckCircleIconOutline,
  BoltIcon
} from '@heroicons/react/24/outline'

type Props = {
  name: string
  preferredVendor: boolean
  preferredVendorBadge: string | null
  instantBook?: boolean
  profileApproved?: boolean
}
const TruckNameSection = ({
  name,
  preferredVendor,
  preferredVendorBadge,
  instantBook,
  profileApproved
}: Props) => {
  return (
    <div className="mb-4 lg:mb-0 flex flex-col sm:flex-row sm:flex-nowrap items-start justify-start">
      <h1 className="sm:text-5xl text-4xl text-white font-extrabold mr-4 line-clamp-2 pb-1">
        {name}
      </h1>
      <div className="flex flex-row items-center sm:items-start sm:flex-col md:flex-row sm:mt-0 mt-1">
        {preferredVendor && (
          <div>
            <div className="flex flex-row items-center sm:mt-2 whitespace-pre-wrap">
              <Tooltip
                button={
                  <div className="flex items-center flex-col lg:flex-row">
                    <CheckCircleIcon className="sm:block hidden w-8 h-8 text-orange-500" />
                    <CheckCircleIconOutline className="text-orange-500 block sm:hidden w-8 h-8" />
                    <p className="ml-1 text-sm text-gray-200 text-center lg:text-left underline">
                      Preferred<span className="hidden md:inline"> Vendor</span>
                    </p>
                  </div>
                }
                content={preferredVendorBadge}
                title="Preferred Vendor"
              />
            </div>
          </div>
        )}
        {profileApproved && (
          <div className="ml-2 flex flex-row items-center sm:mt-2">
            <CheckBadgeIcon className="w-8 h-8 text-green-400" />
            <p className="ml-1 text-sm text-gray-200">Approved profile</p>
          </div>
        )}
        {instantBook && (
          <div className="ml-2">
            <div className="flex flex-row items-center justify-center sm:mt-2 whitespace-pre-wrap">
              <Tooltip
                button={
                  <div className="flex items-center flex-col lg:flex-row">
                    <BoltIcon className="sm:block hidden w-8 h-8 text-orange-500" />
                    <BoltIcon className="block sm:hidden w-8 h-8 text-orange-500" />
                    <p className="ml-1 text-sm text-gray-200 text-center lg:text-left underline">
                      Instant<span className="hidden xs:inline"> Book</span>
                    </p>
                  </div>
                }
                content="This vendor has enabled Instant Book. Submit a catering request and see this truck automatically apply with a catering proposal."
                title="Instant Book"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default TruckNameSection
